import * as Sentry from '@sentry/react';

export const validateToken = async (token: string): Promise<boolean> => {
  try {
    const { VITE_DEV_AUTH_ENDPOINT_URL } = import.meta.env;
    const baseUrl =
      VITE_DEV_AUTH_ENDPOINT_URL || 'https://authdev.scribebrain.com';
    const response = await fetch(`${baseUrl}/api/v1/user/validate`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.status === 200;
  } catch (error) {
    Sentry.logger.error('Token validation error', {
      error: String(error),
    });
    return false;
  }
};
